<template>
  <component-page :code-view="codeView" :color-preview-block="getColor">
    <template #description>
      Неинтерактивный компонент бейдж
    </template>
    <template #component>
      <r-badge v-bind="props" />
    </template>
    <template #props>
      <r-row
        class="mb-6"
        gap-hidden>
        <r-switcher
          title="inversion"
          v-model="props.inversion"
        />
        <r-switcher
          title="isClose"
          v-model="props.isClose"
        />
      </r-row>
      <r-row
        gap-hidden>
        <r-col
          :cols="{ widest: 6, wide: 6, middle: 6, narrow: 6 }">
            <r-select
              label="Size"
              :items="sizeType"
              v-model="props.size"
              />
          </r-col>
        <r-col
          :cols="{ widest: 6, wide: 6, middle: 6, narrow: 6 }">
            <r-select
              label="Color"
              :items="colorType"
              v-model="props.color"
              />
          </r-col>
        <r-col
          :cols="{ widest: 6, wide: 6, middle: 6, narrow: 6 }">
            <r-input
            :is-clear="false"
              label="Title"
              v-model="props.title"
              />
          </r-col>
      </r-row>
    </template>
    <template #api>
      <div class="taleggio mb-8">Props</div>
      <r-table
        class="mb-8"
        :headers="headersProps"
        :items="itemsProps"
      >
        <template #nameProp="{ item }">
          <div  v-html="item.nameProp"/>
        </template>
        <template #typeData="{ item }">
          <div  v-html="item.typeData"/>
        </template>
        <template #defaultValue="{ item }">
          <div  v-html="item.defaultValue"/>
        </template>
      </r-table>
    </template>
  </component-page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { generateCodeToString } from '@/utils/markupCode';
import ComponentPage from '@/layouts/ComponentPage.vue';

@Component({
  components: { ComponentPage },
})
export default class Badge extends Vue {
  headersProps = [
    {
      field: 'nameProp',
      name: 'Название параметра',
      description: 'Наименование входного параметра',
      slot: true,
    },
    {
      field: 'typeData',
      name: 'Тип данных',
      description: 'Применение входного параметра с типом данных',
      slot: true,
    },
    {
      field: 'defaultValue',
      name: 'Значение по умолчанию',
      slot: true,
    },
    {
      field: 'description',
      name: 'Описание',
      description: 'Описание входного параметра',
    },
  ]

  itemsProps = [
    {
      nameProp: '<span class="rocky--text">title</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="fargo--text">Обязательный параметр</span>',
      description: 'Текст в теле компонента',
    },
    {
      nameProp: '<span class="rocky--text">color</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="matrix--text">"rocky"</span>',
      description: 'Цвет фона компонента или текста при параметре "transparent"',
    },
    {
      nameProp: '<span class="rocky--text">size</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="matrix--text">"psamiaphe"</span>',
      description: 'Размер компонента',
    },
    {
      nameProp: '<span class="rocky--text">transparent</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Убирает цвет фона и применяет к тексту выбранный цвет в свойстве "color"',
    },
    {
      nameProp: '<span class="rocky--text">inversion</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Изменяет цвет текста, с темного на светлый',
    },
    {
      nameProp: '<span class="rocky--text">isClose</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Отображение блока эвента бейджа',
    },
    {
      nameProp: '<span class="rocky--text">closeCallback</span>',
      typeData: '<span class="matrix--text">Function</span>',
      defaultValue: '<span class="fightclub--text">() => {}</span>',
      description: 'Функция колбека для выполнения клика по контролу isClose',
    },
  ]

  props = {
    title: 'Title Badge',
    color: 'rocky',
    inversion: false,
    isClose: false,
    size: 'psamiaphe',
    closeCallback: this.isClose,
  }

  sizeType = [
    {
      id: 'psamiaphe',
      title: 'psamiaphe',
    },
    {
      id: 'ptelea',
      title: 'ptelea',
    },
    {
      id: 'arasine',
      title: 'arasine',
    },
  ]

  colorType = [
    {
      id: 'rocky',
      title: 'rocky',
    },
    {
      id: 'matrix',
      title: 'matrix',
    },
    {
      id: 'lebowski',
      title: 'lebowski',
    },
    {
      id: 'fargo',
      title: 'fargo',
    },
    {
      id: 'gentlemen',
      title: 'gentlemen',
    },
    {
      id: 'metropolis',
      title: 'metropolis',
    },
    {
      id: 'fightclub',
      title: 'fightclub',
    },
    {
      id: 'aquaman',
      title: 'aquaman',
    },
    // {
    //   id: 'goodfellas',
    //   title: 'goodfellas',
    // },
    {
      id: 'amelie',
      title: 'amelie',
    },
    {
      id: 'lost',
      title: 'lost',
    },
    {
      id: 'mulholland',
      title: 'mulholland',
    },
    {
      id: 'innocents',
      title: 'innocents',
    },
  ]

  isClose() {
    console.log('isClose');
  }

  get codeView() {
    return generateCodeToString('badge', this.props);
  }

  get getColor() {
    return this.props.color === 'amelie' ? 'inception' : 'white';
  }
}
</script>

<style lang="scss" scoped>
.component{
  &__view{
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
